var $ = require('jquery');
var Utils = require('./utils');
'use strict';

var PLUGIN_NAME = 'feedAgeTags';

var	DEFAULTS = {
	tags: [],
	targetInputName: 'frm.tagIds',
	messages: {
		title: 'Věk dítěte',
		extendedTitle: 'Zúžit hledání podle věku dítěte',
		noLimit: 'Bez omezení',
		my: 'Moje děti',
		c1: 'Těhotenství',
		c2: 'Kojenec',
		c3: 'Batole'
	},
	events: {
		AGE_TAG_CHANGED: 'AGE_TAG_CHANGED'
	},
	enableHtml5History: false
};

/**
 *
 * @param selector
 * @param options
 * @constructor
 */
var FeedAgeTags = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;

	this.state = {};

	this.initialise_();
};

/**
 *
 * @private
 */
FeedAgeTags.prototype.initialise_ = function() {
	this.$form = this.$t.parents('form:first');
	this.state.opened = false;
	this.utils = new Utils();

	this.renderStarterDiv_();
	this.separateAgeTagCategories_();
	this.renderSelectContent_();
	this.bindTagsEvents_();
	this.bindEvents_();

	if (this.options.enableHtml5History) {
		this.activateHistoryHandler_();
	}
};

FeedAgeTags.prototype.renderStarterDiv_ = function() {
	var self_ = this;
	this.$starterDiv = $('<div class="starter-div">'+this.options.messages.title+'</div>').appendTo(this.$t);
	this.$selectedTagInfo = $('<div class="selected-tag-info">'+this.options.messages.noLimit+'</div>').appendTo(this.$starterDiv);

	this.$starterDiv.on('click', function(event) {
		if (self_.state.opened == false) {
			self_.$selectContentWrapper.fadeIn();
			self_.state.opened = true;

			$(event.currentTarget).addClass('opened');
		} else {
			self_.closeSelectContent_();
		}
	});
};

FeedAgeTags.prototype.closeSelectContent_ = function() {
	this.$selectContentWrapper.fadeOut();
	this.state.opened = false;
	this.$starterDiv.removeClass('opened');
};

FeedAgeTags.prototype.separateAgeTagCategories_ = function() {
	var tag;
	this.tags = {
		my: [],
		c1: [],
		c2: [],
		c3: []
	};

	for (var i = 0; i <  this.options.tags.length; i++) {
		tag = this.options.tags[i];
		if (tag.type == 'userAgeTag') {
			this.tags.my.push(tag);
		} else {
			if ((!tag.ageFrom || tag.ageFrom < 0) && tag.ageTo < 0) {
				this.tags.c1.push(tag);
			} else if (tag.ageFrom < 340 ) {
				this.tags.c2.push(tag);
			} else {
				this.tags.c3.push(tag);
			}
		}
	}
};

FeedAgeTags.prototype.renderSelectContent_ = function() {
	this.$selectContentWrapper = $('<div class="select-content-wrapper'+ (this.tags.my.length > 0 ? ' with-my-children' : '') +'"></div>').appendTo(this.$t);
	this.$selectContent = $('<div class="select-content"></div>').appendTo(this.$selectContentWrapper);
	this.$selectContent.append('<h3>' + this.options.messages.extendedTitle + '</h3>');
	this.$selectContent.append('<p><a data-tag-id="0" data-tag-name="' + this.options.messages.noLimit  + '" href="javascript:void(0)" class="tag active">' + this.options.messages.noLimit + '</a></p>');
	for (var tagGroup in this.tags) {
		if (this.tags.hasOwnProperty(tagGroup)) {
			this.renderAgeTagsGroup_(tagGroup, this.tags[tagGroup]);
		}
	}
};

FeedAgeTags.prototype.renderAgeTagsGroup_ = function(groupId, group) {
	var str = '';
	var activeClass = '';
	var tagName = '';
	if (group.length > 0) {
		str += '<div class="select-content-group">';
		str += '	<h4>'+this.options.messages[groupId]+'</h4>';
		str += '	<ul>';
		for (var i = 0; i < group.length; i++) {
			activeClass = '';
			tagName = '';
			if (group[i].tagName && group[i].tagName != '') {
				tagName = ' (' + group[i].tagName + ')';
			}
			if ($.isArray(window.feedTags) && $.inArray(group[i].id, window.feedTags) > -1) {
				activeClass = ' active';
				$('a.tag', this.$selectContent).removeClass('active');
				$('a.tag[data-tag-id="'+group[i].id+'"]', this.$selectContent).addClass('active');
				this.$selectedTagInfo.text((group[i].tagName || group[i].name));
			}
			str += '<li><a data-tag-id="'+group[i].id+'" data-tag-name="' + (group[i].tagName || group[i].name)  + '" href="javascript:void(0)" class="tag' + activeClass + '">'+group[i].name+tagName+'</ad>';
		}
		str += '	</ul>';
		str += '</div>';
	}
	this.$selectContent.append(str);
};

FeedAgeTags.prototype.bindTagsEvents_ = function() {
	var self_ = this;
	this.$selectContent.on('click', 'a.tag', function(event) {
		event.preventDefault();
		var actualTagId = parseInt($(event.currentTarget).data('tagId'));
		var actualTagName = $(event.currentTarget).data('tagName');
		var isInArray = self_.checkActiveTagsForAgeTagPresence_(actualTagId);

		// remove existing age tag from the tags array
		if (isInArray.position > -1 && !isInArray.sameTag) {
			window.feedTags.splice(isInArray.position, 1);
		}

		// push new tag to the tags array, if there is none of actual Id
		if (actualTagId && actualTagId > 0 && !isInArray.sameTag) {
			window.feedTags.push(actualTagId);
			window.feedTagsMetadata['tag-'+actualTagId] = { id: actualTagId, name: actualTagName, categorySystemId: 'CHILD_AGE' };
			self_.refreshAgeTagsAndCloseSelect_(actualTagId, $(event.currentTarget));
		}

		if (actualTagId == 0) {
			self_.refreshAgeTagsAndCloseSelect_(actualTagId, $(event.currentTarget));
		}

		if (isInArray.sameTag) {
			self_.closeSelectContent_();
		}

	});
};

FeedAgeTags.prototype.checkActiveTagsForAgeTagPresence_ = function(actualTagId) {
	for (var i = 0; i < this.options.tags.length; i++) {
		var tag = this.options.tags[i];
		if ($.inArray(tag.id, window.feedTags) > -1) {
			return {
				position: $.inArray(tag.id, window.feedTags),
				sameTag: actualTagId === tag.id
			}
		}
	}
	return {
		position: -1
	};
};

FeedAgeTags.prototype.refreshAgeTagsAndCloseSelect_ = function(tagId, $tag) {
	this.$t.trigger(this.options.events.AGE_TAG_CHANGED);
	this.activateTag_(tagId, $tag.data('tagName'));
	this.closeSelectContent_();

	var tagParams = '?';
	for (var i = 0; i < window.feedTags.length; i++) {
		var tag = window.feedTags[i];
		tagParams += 'frm.tagIds=' + window.feedTags[i] + '&';
	}
	tagParams += 'frm.fulltext=' + this.utils.removeDiacritics($('input[name="frm.fulltext"]', this.$form).val());
	this.reRenderFormInputs_();
	this.utils.executePartialUpdate(this.options.feedUrl + tagParams + '&tagIds=', 'article-listing');
};

FeedAgeTags.prototype.activateTag_ = function(tagId, tagName) {
	$('a.tag', this.$selectContent).removeClass('active');
	$('a.tag[data-tag-id="'+tagId+'"]', this.$selectContent).addClass('active');
	this.$selectedTagInfo.text(tagName);
};

FeedAgeTags.prototype.reRenderFormInputs_ = function() {
	$('input[name="'+this.options.targetInputName+'"]', this.$form).remove();
	for (var i = 0; i < window.feedTags.length; i++) {
		this.$form.append('<input type="hidden" name="'+this.options.targetInputName+'" value="'+window.feedTags[i]+'">');
	}
};

FeedAgeTags.prototype.bindEvents_ = function() {
	var self_ = this;
	this.$form.on('AUTOCOMPLETE_RESULT_RENDERED', function() {
		self_.closeSelectContent_();
	});
};

FeedAgeTags.prototype.activateHistoryHandler_ = function() {
	var self_ = this;
	$(window).off('popstate.feedagetags').on('popstate.feedagetags', function() {
		self_.findActiveTagsInFeedTagsAndActivateIt_();
	});

	if (history && history.state && history.state.feedListing && (history.state.feedListing.tags || history.state.feedListing.fulltext)) {
		this.findActiveTagsInFeedTagsAndActivateIt_();
	}
};

FeedAgeTags.prototype.findActiveTagsInFeedTagsAndActivateIt_ = function() {
	var isAgeTagPresent = false;
	for (var i = 0; i < window.feedTags.length; i++) {
		var id = window.feedTags[i];
		if (window.feedTagsMetadata['tag-'+id] && window.feedTagsMetadata['tag-'+id].categorySystemId && window.feedTagsMetadata['tag-'+id].categorySystemId === 'CHILD_AGE') {
			this.activateTag_(id, window.feedTagsMetadata['tag-'+id].name);
			isAgeTagPresent = true;
		}
	}
	if (!isAgeTagPresent) {
		this.activateTag_(0, this.options.messages.noLimit);
	}
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new FeedAgeTags(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.feed-agetags-select.js